(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["module-shop-by-brand"] && !Shopify.designMode) return;
  try {
    

const brandNames = document.querySelectorAll('[data-brand-name]');
const brandImages = document.querySelectorAll('.brand_image_tag')

brandNames.forEach(brandName => {
  brandName.addEventListener('mouseover', (e)=>{

    document.querySelector('[data-brand-name].active').classList.remove('active')
    brandName.classList.add('active');

    let imageId = brandName.dataset.imageId;
    let brandImage =  document.querySelector(`img.brand_image_tag[data-image-id="{imageId}"]`);
    toggleImages(imageId)
  });
});

function toggleImages(imgId) {
  brandImages.forEach(img => {
    if(img.dataset.imageId === imgId) {
      img.classList.remove("brand_image_tag--hidden")
    } else {
      img.classList.add("brand_image_tag--hidden")
    }
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-brands"] && !Shopify.designMode) return;
  try {
    
  const brandLinks = document.querySelectorAll('[data-size] [data-brandlist]');
  brandLinks.forEach(link => {
    link.addEventListener('click', () => {
      document.querySelector('.active[data-brandlist]').classList.remove('active');
      link.classList.add('active');
      document.querySelector('[data-open]').removeAttribute('data-open');
      document.querySelector(`.brand-container[data-brandlist="${link.getAttribute('data-brandlist')}"]`).setAttribute('data-open', '');
    })
  })

  const breakpoint = window.matchMedia('(max-width: 767px)')
  breakpoint.addListener(check_breakpoint)
  const list_1 = document.querySelector(`#brands .brand-container[data-brandlist="1"]`)
  const list_2 = document.querySelector(`#brands .brand-container[data-brandlist="2"]`)
  let row_1_size = 0;
  let row_2_size = 0;
  function check_breakpoint() {
    let size_1 = list_1.children.length;
    let size_2 = list_2.children.length;
    if (breakpoint.matches) {// on small screens
      row_1_size = Math.ceil(size_1 / 2)
      row_2_size = Math.ceil(size_2 / 2)
    }else{
      row_1_size = Math.ceil(size_1 / 3)
      row_2_size = Math.ceil(size_2 / 3)
    }
    list_1.setAttribute("style", `grid-template-rows: repeat(${row_1_size}, auto)`)
    list_2.setAttribute("style", `grid-template-rows: repeat(${row_2_size}, auto)`)
  }
  check_breakpoint()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
  window.addEventListener("DOMContentLoaded", () => {
    const faqLinks = document.querySelectorAll('[data-faq-menu]');
    faqLinks.forEach(link => {
      const anchor = link.getAttribute('href');
      link.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
          top: document.querySelector(anchor).offsetTop,
          behavior: 'smooth'
        });
      })
    });

    const elFaqContainer = document.querySelector(".js-faq-container");
    const elFirstSection = document.querySelectorAll('.js-faq-section')[0];
    elFirstSection.classList.add('first');
    elFirstSection.style.marginTop = `-${elFaqContainer.getBoundingClientRect().height}px`
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  const pwdBtn = document.querySelector('[data-enter-site-password]');
  pwdBtn.addEventListener("click", () => {
    document.querySelector('[data-storefront-password-screen]').style.display = 'block';
  });

  const closeBtn = document.querySelector('.close-password');
  closeBtn.addEventListener("click", () => {
    document.querySelector('[data-storefront-password-screen]').style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();
})();
